// extracted by mini-css-extract-plugin
export default {"border":"Footer_border__WtR0t","body":"Footer_body__emm9z"};